/**
 * Fixed demo launch for P1_VP12 (testing).
 * Taken from the working Team Vendor Portal URL on BestBuy Test
 * (Chrome history: p1web.eadfm.com /team.html#/vendor-portal?…).
 * Later: replace with vendor-contact login + project switcher.
 */
export const FIXED_API_SERVER = '/bestbuytest'

/**
 * When true, ignore URL/session overrides and always use FIXED_LAUNCH.
 * Keep false so Team/Admin deep-links (?projectId=&folderId=) work.
 * FIXED_LAUNCH remains the fallback when the URL has no launch ids.
 */
export const FORCE_FIXED_LAUNCH = false

export const FIXED_LAUNCH = {
  projectId: '221',
  folderId: '102249',
  spaceId: '91718',
  projectName: 'NS-BTSTM Medium Portable Bluetooth Speaker',
  folderName: 'NS-BTSTM Medium Portable Bluetooth Speaker - Fenda',
  viewAs: 'vendor'
}

/** @deprecated use FIXED_LAUNCH */
export const DEFAULT_DEMO_LAUNCH = FIXED_LAUNCH

export function getDemoLaunch () {
  return { ...FIXED_LAUNCH }
}

export function setDemoLaunch () {
  return { ...FIXED_LAUNCH }
}

export function hasDemoLaunchIds () {
  return !!(FIXED_LAUNCH.projectId && FIXED_LAUNCH.folderId)
}
